import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement, } from 'react';
import { styled } from '../../utils';
import { FormFlexItem } from './FormFlexItem';
// TODO: Integrate to FormGrid and create styleguidist examples
export function FormFlex({ rowGap, columnGap, children, flexGrow, flexBasis, className, align, width, height, flexWrap, flexDirection, justifyContent, disableWrapChild, sx, }) {
    return (_jsx(FormFlexRoot, { rowGap,
        columnGap,
        align,
        flexWrap,
        justifyContent,
        height,
        sx,
        flexDirection, className: className, children: disableWrapChild
            ? children
            : Children.map(children, (child) => {
                if (!child)
                    return null;
                if (isValidElement(child) &&
                    child.type === FormFlexItem) {
                    //TODO: fix overwrite
                    return cloneElement(child, {
                        ...(rowGap && { rowGap }),
                        ...(columnGap && { columnGap }),
                        ...(flexGrow && { flexGrow }),
                        ...(width && { width }),
                    });
                }
                return (_jsx(FormFlexItem, { rowGap: rowGap, columnGap: columnGap, flexGrow: flexGrow, flexBasis: flexBasis, width: width || 'auto', children: child }));
            }) }));
}
const FormFlexRoot = styled('div', {
    shouldForwardProp: (prop) => prop !== 'flexWrap' &&
        prop !== 'align' &&
        prop !== 'columnGap' &&
        prop !== 'rowGap' &&
        prop !== 'justifyContent' &&
        prop !== 'height' &&
        prop !== 'flexDirection',
    name: 'FormFlexRoot',
})(({ theme, rowGap, columnGap, align, flexWrap, justifyContent, height, flexDirection, }) => ({
    display: 'flex',
    flexWrap: flexWrap ?? 'wrap',
    ...(align && {
        alignItems: align,
    }),
    rowGap: theme.spacing(rowGap),
    columnGap: theme.spacing(columnGap),
    // ...(theme.supports.flexGap
    //   ? {
    //     }
    //   : {
    //       margin: theme.spacing(-(columnGap / 2), -(rowGap / 2)),  FIXME: theme.supports doesnt work
    //     }),
    ...(justifyContent && { justifyContent }),
    ...(height && { height }),
    ...(flexDirection && { flexDirection }),
}));
